import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import "./tree.css";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import { DialogActions } from "@material-ui/core";
import TaxonomyTree from "./TaxonomyTree";
import { Trans, withTranslation } from "react-i18next";
import Button from "@material-ui/core/Button";

const styles = (theme) => ({
  formControl: {
    minWidth: 182,
  },
  taxonomyDialog: {
    minWidth: 300,
    minHeight: 300,
    overflow: "auto",
  },
});
const equal = require("deep-equal");
const areObjectsEqual = (obj1, obj2) => {
  return equal(obj1, obj2) ? true : false;
};
export class TaxonomySelector extends Component {
  state = {
    // instance: new Date().getTime().toString(),
    taxonomyDialogOpen: false,
    canSelect: true,
  };

  componentDidMount() {
    this.setState({ canSelect: !this.props.filter });
  }

  componentDidUpdate(prevProps, prevState) {
    // if (prevState.input !== this.state.input) {
    //   // let matching = this.state.defaultSuggestions.filter(s => s.label === this.state.input);
    //   let matching = this.props.taxonomySuggestions.filter(
    //     s => s.label === this.state.input
    //   );
    //   if (matching.length > 0) {
    //     this.setState({ activeNode: matching[0].node });
    //     this.props.onNodeSelected(matching[0].node);
    //   } else {
    //     this.setState({ activeNode: null });
    //   }
    // }
  }

  keypress = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      this.openTaxonomyDialog();
    }
  };

  render() {
    const { classes, t } = this.props;
    return (
      <>
        <TextField
          aria-label="Taxonomy node selector"
          error={this.props.error}
          fullWidth={!!this.props.fullWidth}
          onKeyDown={this.keypress}
          disabled={this.props.disabled}
          id="taxonomyNode"
          label={
            this.props.noLabel
              ? null
              : this.props.inputLabel
                ? this.props.inputLabel
                : t("search_bar_pick_taxonomy_node")
          }
          value={
            this.props.filter
              ? this.props.filter.length > 1
                ? areObjectsEqual(
                    this.props.filter,
                    this.props.taxonomyNodeLookup
                  )
                  ? "All Knowledge"
                  : "Multiple Selections"
                : this.props.filter.length === 1
                  ? this.props.filter[0].hasOwnProperty("name")
                    ? this.props.filter[0].name
                    : this.lookupName(this.props.filter[0])
                  : "None"
              : "All Knowledge"
          }
          onClick={this.openTaxonomyDialog}
          margin="none"
          InputProps={{
            readOnly: true,
          }}
        />
        <Dialog
          open={this.state.taxonomyDialogOpen}
          onClose={this.handleTaxonomyDialogClose}
          style={{ zIndex: 10002 }}
        >
          <DialogTitle>
            <Trans
              i18nKey={
                this.props.topicSelector
                  ? "taxonomy_tree_topic_header"
                  : "taxonomy_tree_header"
              }
            />
          </DialogTitle>
          <DialogContent className={classes.taxonomyDialog}>
            <TaxonomyTree
              multiSelect={this.props.multiSelect}
              onNodeSelected={this.onNodeSelected}
              topicSelector={this.props.topicSelector}
              allowedSelections={this.props.allowedSelections}
              showWorkflow={this.props.showWorkflow}
              filter={this.props.filter ? this.props.filter : []}
              showExpertStatus={this.props.showExpertStatus}
              treeType={this.props.treeType}
              includeRoledUsers={this.props.includeRoledUsers}
            >
              {" "}
            </TaxonomyTree>
          </DialogContent>
          <DialogActions>
            {/* <Button
              onClick={this.handleExpandAll}
              color="primary"
            >
              <Trans i18nKey={"Expand All"}></Trans>
            </Button>
            <Button
              onClick={this.handleCollapseAll}
              color="primary"
            >
              <Trans i18nKey={"Expand All"}></Trans>
            </Button> */}

            {!this.props.multiSelect ? (
              <Button onClick={this.handleTaxonomyDialogCancel} color="primary">
                <Trans i18nKey="global_close" />
              </Button>
            ) : (
              <Button
                onClick={this.handleTaxonomyDialogSubmit}
                color="primary"
                disabled={this.state.canSelect}
              >
                <Trans
                  i18nKey={
                    this.props.multiSelect === true
                      ? "global_done"
                      : "global_select"
                  }
                />
              </Button>
            )}
          </DialogActions>
        </Dialog>
      </>
    );
  }
  // getTaxonomyNodeName(id) {
  //   if (id === 0) return "";
  //   return this.props.taxonomyNodeLookup[id];
  // }
  lookupName = (selected) => {
    let matchArray = this.props.taxonomyNodeLookup.filter((ele) => {
      if (selected.type === "taxonomy") {
        return ele.type === selected.type && ele.id === selected.id;
      } else {
        return ele.type === selected.type && ele.id === selected.id;
      }
    });
    return matchArray.length > 0 ? matchArray[0].name : "None";
  };

  openTaxonomyDialog = () => {
    if (this.props.disabled) return;
    this.props.onTouch && this.props.onTouch();
    this.setState({ taxonomyDialogOpen: true });
  };
  handleTaxonomyDialogClose = () => {
    this.setState({ taxonomyDialogOpen: false });
  };
  handleTaxonomyDialogSubmit = () => {
    this.handleTaxonomyDialogClose();
  };
  handleTaxonomyDialogCancel = () => {
    this.setState({ taxonomyDialogOpen: false, taxonomyNode: { name: "" } });
  };
  onNodeSelected = (e) => {
    !this.props.multiSelect && this.handleTaxonomyDialogClose();
    this.props.onNodeSelected(e);
    this.setState({ canSelect: false });
  };
}

const mapStateToProps = (state) => ({
  taxonomyTree: state.taxonomy.taxonomyTree,
  taxonomyNodeLookup: state.taxonomy.taxonomyNodeLookup,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(TaxonomySelector)));
